var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail_Icon",
    "data-name": "Mail Icon",
    transform: "translate(-653 -305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16994",
    "data-name": "Path 16994",
    d: "M-2625.363-301.241h44.851v4.01l-22.053,13.175-23.772-15.7Z",
    transform: "translate(3286 619)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "forward_to_inbox_black_24dp",
    transform: "translate(653 305)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10729",
    "data-name": "Rectangle 10729",
    width: 60,
    height: 60,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16993",
    "data-name": "Path 16993",
    d: "M47.238,4H7.026A5.041,5.041,0,0,0,2,9.026V39.185a5.041,5.041,0,0,0,5.026,5.026H29.645V39.185H7.026V14.053L27.132,26.619,47.238,14.053V26.619h5.026V9.026A5.041,5.041,0,0,0,47.238,4ZM27.132,21.592,7.026,9.026H47.238ZM44.725,31.645,54.777,41.7,44.725,51.751v-7.54H34.672V39.185H44.725Z",
    transform: "translate(3.026 6.053)",
    fill: "#999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.4dbc2737.svg";
export { ForwardRef as ReactComponent };